import { useState } from 'react'
import { useTranslation } from "react-i18next";
import './translate';
import './styles/style.css';
import Hello from './components/hello.jsx'
// import Header from './components/game/header.jsx';
// import HowToPlay from './components/game/howToPlay.jsx';
import Game from './components/Game.jsx';
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import LoginRoute from './routes/Login.jsx';
import MainPage from './routes/MainPage';
import { AuthProvider } from './providers/AuthProvider.jsx';
import { PrivateRoute } from './providers/PrivateRoute.jsx';
import { LoginProvider } from './providers/LoginProvider.jsx';
import RegistrRoute from './routes/Registr';
function App() {
    const { i18n } = useTranslation();


    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    }

    return (
        <AuthProvider>
        <Router>
            <Routes>
                <Route path='/' element={<MainPage/>}/>
                <Route path='/games/aviator' element={<PrivateRoute><Game /></PrivateRoute>} />
                <Route path='/login' element={<LoginRoute/>}/>
                <Route path='/registration' element={<RegistrRoute />} />
            </Routes>
        </Router>
        </AuthProvider>

    )
}

export default App
